import { ITransshipment, TTransshipmentStepId } from '../../types';

const cnh = {
  path: 'documentos/cnh',
  next: (trans: ITransshipment): TTransshipmentStepId => {
    if (trans.data.status !== 'retake-documents') {
      return 'selfie-page';
    }

    if (
      trans.data.documents.some(
        (doc) => doc.category === 'selfie' && doc.status === 'invalid'
      )
    ) {
      return 'selfie-page';
    }

    return trans.type === 'representative'
      ? 'documents-success-page'
      : 'success-page';
  },
};

export default cnh;
